import { Customer } from 'services/api/entities/crm/pmi'
import { EntityDescriptor } from '.'
import { formatBusinessUserCsv } from './common'

export const pmi: EntityDescriptor<Customer> = {
  format: formatBusinessUserCsv,
}
